import { useRef, useState } from 'react';
import TextField from '../../TextField';
import useRenameSession from '../hooks/useRenameSession';

type Props = {
  sessionId: string;
  currentTitle: string;
  onDone: () => void;
};

const InlineTitleEdit = ({ sessionId, currentTitle, onDone }: Props) => {
  const [value, setValue] = useState(currentTitle);
  const { mutate: rename } = useRenameSession();
  const doneRef = useRef(false);

  const commit = () => {
    if (doneRef.current) return;
    doneRef.current = true;
    const trimmed = value.trim();
    if (trimmed && trimmed !== currentTitle.trim()) {
      rename({ sessionId, title: trimmed });
    }
    onDone();
  };

  const cancel = () => {
    if (doneRef.current) return;
    doneRef.current = true;
    onDone();
  };

  return (
    <TextField
      autoFocus
      fullWidth
      variant="outlined"
      size="extraSmall"
      value={value}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => setValue(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          commit();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          cancel();
        }
      }}
    />
  );
};

export default InlineTitleEdit;
